import { v4 as uuid } from 'uuid';
import { eJudgementLienDocumentType } from './eJudgementLienDocumentType';
import { DateTime } from 'luxon';
import { isNil } from 'lodash';

export interface IJudgementInformationResponse {
  names_run?: string | null;
  clear: boolean;
  judgements?: IJudgementResponse[] | null;
}

export interface IJudgementInformationData {
  namesRun?: string | null;
  clear: boolean;
  judgements?: IJudgementData[] | null;
}

export const createDefaultJudgementInformationData = (): IJudgementInformationData => ({ clear: true });

export const convertJudgementInformationResponseToJudgementInformationData = (
  res: IJudgementInformationResponse
): IJudgementInformationData => ({
  namesRun: res.names_run,
  clear: res.clear,
  judgements: isNil(res.judgements)
    ? res.judgements
    : res.judgements!.map((j) => convertJudgementResponseToJudgementData(j)),
});

export const convertJudgementInformationDataToJudgementInformationResponse = (
  data: IJudgementInformationData
): IJudgementInformationResponse => ({
  names_run: data.namesRun,
  clear: data.clear,
  judgements: isNil(data.judgements)
    ? data.judgements
    : data.judgements!.map((j) => convertJudgementDataToJudgementResponse(j)),
});

export interface IJudgementResponse {
  id: string;
  created_at?: string;
  judgement_type?: eJudgementLienDocumentType | null;
  other_judgement_type?: string | null;
  creditor_name?: string | null;
  debtor_name?: string | null;
  amount?: number | null;
  file_date?: string | null;
  book?: string | null;
  additional_information?: string | null;
}

export interface IJudgementData {
  id: string;
  createdAt?: string;
  judgementType?: eJudgementLienDocumentType | null;
  otherJudgementType?: string | null;
  creditorName?: string | null;
  debtorName?: string | null;
  amount?: number | null;
  fileDate?: string | null;
  book?: string | null;
  additionalInformation?: string | null;
}

export const createDefaultJudgementData = (): IJudgementData => ({ id: uuid(), createdAt: DateTime.local().toISO() });

export const convertJudgementResponseToJudgementData = (res: IJudgementResponse): IJudgementData => ({
  id: res.id,
  createdAt: res.created_at,
  judgementType: res.judgement_type,
  otherJudgementType: res.other_judgement_type,
  creditorName: res.creditor_name,
  debtorName: res.debtor_name,
  amount: res.amount,
  fileDate: res.file_date,
  book: res.book,
  additionalInformation: res.additional_information,
});

export const convertJudgementDataToJudgementResponse = (data: IJudgementData): IJudgementResponse => ({
  id: data.id,
  created_at: data.createdAt,
  judgement_type: data.judgementType,
  other_judgement_type: data.otherJudgementType,
  creditor_name: data.creditorName,
  debtor_name: data.debtorName,
  amount: data.amount,
  file_date: data.fileDate,
  book: data.book,
  additional_information: data.additionalInformation,
});
